import type { CropRect } from '@/services/entryService';

export function objectPositionFromCrop(crop?: CropRect, fallback?: { x?: number; y?: number }) {
  if (crop) {
    const cx = (crop.crop_x + crop.crop_w / 2) * 100;
    const cy = (crop.crop_y + crop.crop_h / 2) * 100;
    return `${cx}% ${cy}%`;
  }
  const fx = fallback?.x ?? 0.5;
  const fy = fallback?.y ?? 0.5;
  return `${fx * 100}% ${fy * 100}%`;
}
